/**
 * @file actions
 */

import Action from '../lib/Action';
import getCityInfo from '../lib/getCityInfo';

class SetCity extends Action {
    constructor(city) {
        super();
        this.city = city;
        Object.assign(this, getCityInfo(city));
    }
}

class PannelFieldsChanged extends Action {
    /**
     * @param  {object} props  current form props
     * @param  {object} fields changed filelds
     */
    constructor(props, fields) {
        super();
        //calculate next pannels props
        let nextProps = Object.keys(props).filter(
            (key) => key !== 'dispatch'
        ).reduce((nextProps, key) => {
            nextProps[key] = props[key];
            if (fields[key]) {
                nextProps[key] = fields[key].value;
            }
            return nextProps;
        }, {})
        Object.assign(this, nextProps);
    }
}

class DropFilterMarker extends Action {
    constructor(point) {
        super();
        this.point = point;
    }
}

class ResetStartFilter extends Action {}

export {
    PannelFieldsChanged,
    DropFilterMarker,
    ResetStartFilter,
    SetCity
};



// WEBPACK FOOTER //
// ./src/actions/index.js